module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px",
      "height": "auto !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Sales Execution Details")]), _vm._v(" "), (_vm.$sessionsStorage.get('is_Mobile') != 'port') ? _c('Filter-Agency-Modal') : _vm._e(), _vm._v(" "), (_vm.$sessionsStorage.get('is_Mobile') != 'port') ? _c('FilterCBModal') : _vm._e(), _vm._v(" "), _c('ClientCard'), _vm._v(" "), _c('ShipmentTrackCard'), _vm._v(" "), _c('b-button', {
    staticStyle: {
      "font-size": "0.575rem",
      "margin-left": "5px",
      "margin-bottom": "4px"
    },
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.goRolloverCont
    }
  }, [_vm._v("Rollover Container")]), _vm._v(" "), _c('b-button', {
    staticStyle: {
      "font-size": "0.575rem",
      "margin-left": "5px",
      "margin-bottom": "4px"
    },
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.goShipmentTrack
    }
  }, [_vm._v("Shipment Track")]), _c('br')], 1), _vm._v(" "), _c('div', [_c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-card', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('date-range-picker', {
    attrs: {
      "opens": _vm.openLeft,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.clientMaster,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select  Client Name"
    },
    model: {
      value: (_vm.clientIdFilter),
      callback: function($$v) {
        _vm.clientIdFilter = $$v
      },
      expression: "clientIdFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.shipmentTypeList,
      "option-value": "shipmentTypeVal",
      "option-text": "shipmentTypeText",
      "placeholder": "Select Sea / Air"
    },
    model: {
      value: (_vm.shipmentTypeFilter),
      callback: function($$v) {
        _vm.shipmentTypeFilter = $$v
      },
      expression: "shipmentTypeFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.flTypeList,
      "option-value": "flVal",
      "option-text": "flText",
      "placeholder": "Select FCL / LCL"
    },
    model: {
      value: (_vm.fclLclFilter),
      callback: function($$v) {
        _vm.fclLclFilter = $$v
      },
      expression: "fclLclFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.transportTypeName,
      "option-value": "transportTypeVal",
      "option-text": "transportTypeText",
      "placeholder": "Select Export / Import"
    },
    model: {
      value: (_vm.transportTypeFilter),
      callback: function($$v) {
        _vm.transportTypeFilter = $$v
      },
      expression: "transportTypeFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.finalAllPlaceDataPOR,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Place of Receipt"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR')
      }
    },
    model: {
      value: (_vm.PORfilter),
      callback: function($$v) {
        _vm.PORfilter = $$v
      },
      expression: "PORfilter"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.finalAllPlaceDataPOD,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Port of Discharge"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD')
      }
    },
    model: {
      value: (_vm.PODfilter),
      callback: function($$v) {
        _vm.PODfilter = $$v
      },
      expression: "PODfilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.finalAllPlaceDataLP,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Load Port"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataLP')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataLP')
      }
    },
    model: {
      value: (_vm.LPfilter),
      callback: function($$v) {
        _vm.LPfilter = $$v
      },
      expression: "LPfilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.containerList,
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "placeholder": "Select Container Type"
    },
    model: {
      value: (_vm.containerFilter),
      callback: function($$v) {
        _vm.containerFilter = $$v
      },
      expression: "containerFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.shippingList,
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    model: {
      value: (_vm.shippingFilter),
      callback: function($$v) {
        _vm.shippingFilter = $$v
      },
      expression: "shippingFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Enquiry",
      "id": "newClientName",
      "name": "newClientName"
    },
    model: {
      value: (_vm.enquiryFilter),
      callback: function($$v) {
        _vm.enquiryFilter = $$v
      },
      expression: "enquiryFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Assignment",
      "id": "newClientName",
      "name": "newClientName"
    },
    model: {
      value: (_vm.assignmentFilter),
      callback: function($$v) {
        _vm.assignmentFilter = $$v
      },
      expression: "assignmentFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllPickupList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Pickup Location"
    },
    model: {
      value: (_vm.PICKfilter),
      callback: function($$v) {
        _vm.PICKfilter = $$v
      },
      expression: "PICKfilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllHandoverList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Handover Location"
    },
    model: {
      value: (_vm.HANDfilter),
      callback: function($$v) {
        _vm.HANDfilter = $$v
      },
      expression: "HANDfilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllStuffingList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Stuffing Location"
    },
    model: {
      value: (_vm.STUFFfilter),
      callback: function($$v) {
        _vm.STUFFfilter = $$v
      },
      expression: "STUFFfilter"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Container No",
      "id": "containerno",
      "name": "containerno"
    },
    model: {
      value: (_vm.containernoFilter),
      callback: function($$v) {
        _vm.containernoFilter = $$v
      },
      expression: "containernoFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Shipping Bill No.",
      "id": "shippingbillno",
      "name": "shippingbillno"
    },
    model: {
      value: (_vm.shippingbillnoFilter),
      callback: function($$v) {
        _vm.shippingbillnoFilter = $$v
      },
      expression: "shippingbillnoFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Booking No.",
      "id": "validBookingNo",
      "name": "validBookingNo"
    },
    model: {
      value: (_vm.validBookingNoFilter),
      callback: function($$v) {
        _vm.validBookingNoFilter = $$v
      },
      expression: "validBookingNoFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Shipper Invocie No.",
      "id": "continvoiceNo",
      "name": "continvoiceNo"
    },
    model: {
      value: (_vm.continvoiceNoFilter),
      callback: function($$v) {
        _vm.continvoiceNoFilter = $$v
      },
      expression: "continvoiceNoFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Common Filter",
      "id": "commonFilter",
      "name": "commonFilter"
    },
    model: {
      value: (_vm.commonFilter),
      callback: function($$v) {
        _vm.commonFilter = $$v
      },
      expression: "commonFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Vessle Filter",
      "id": "vessleFilter",
      "name": "vessleFilter"
    },
    model: {
      value: (_vm.vessleFilter),
      callback: function($$v) {
        _vm.vessleFilter = $$v
      },
      expression: "vessleFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.statusList,
      "option-value": "statusVal",
      "option-text": "statusText",
      "placeholder": "Select Status"
    },
    model: {
      value: (_vm.statusFilter),
      callback: function($$v) {
        _vm.statusFilter = $$v
      },
      expression: "statusFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.jobList,
      "option-value": "jobVal",
      "option-text": "jobText",
      "placeholder": "Select Status"
    },
    model: {
      value: (_vm.jobFilter),
      callback: function($$v) {
        _vm.jobFilter = $$v
      },
      expression: "jobFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.branchList,
      "id": "branchfilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    model: {
      value: (_vm.branchfilter),
      callback: function($$v) {
        _vm.branchfilter = $$v
      },
      expression: "branchfilter"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "mt-2 justify-content-center",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.filterSearch
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-3",
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("clear")]), _vm._v(" "), (_vm.consoBooking.length > 0) ? _c('b-button', {
    staticClass: "mt-2 ml-3",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export Duplicate Containers' ? true : false,
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getReportsAss('DuplicateContainers', 'Export Duplicate Containers')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.ExcelBtnName) + "\n                "), (_vm.ExcelBtnName != 'Export Duplicate Containers') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.consoBooking.length > 0) ? _c('b-button', {
    staticClass: "mt-2 ml-3",
    attrs: {
      "disabled": _vm.ExcelBtnName1 != 'Export Exp' ? true : false,
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getReportsAss('All_Expense_Excel', 'Export Exp')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.ExcelBtnName1) + "\n                "), (_vm.ExcelBtnName1 != 'Export Exp') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.consoBooking.length > 0) ? _c('b-button', {
    staticClass: "mt-2 ml-3",
    attrs: {
      "disabled": _vm.ExcelBtnName2 != 'Export Add Task' ? true : false,
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getReportsAss('All_AdditionalTask_Excel', 'Export Add Task')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.ExcelBtnName2) + "\n                "), (_vm.ExcelBtnName2 != 'Export Add Task') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.consoBooking.length > 0) ? _c('b-button', {
    staticClass: "mt-2 ml-3",
    attrs: {
      "disabled": _vm.ExcelBtnName4 != 'Export Assignments' ? true : false,
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getSalesAss('All_Sales_Excel', 'Export Assignments')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.ExcelBtnName4) + "\n                "), (_vm.ExcelBtnName4 != 'Export Assignments') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCheckAll),
      expression: "isCheckAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isCheckAll) ? _vm._i(_vm.isCheckAll, null) > -1 : (_vm.isCheckAll)
    },
    on: {
      "click": function($event) {
        _vm.SelectAll(_vm.consoBooking)
      },
      "change": function($event) {
        var $$a = _vm.isCheckAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isCheckAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isCheckAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isCheckAll = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Select / Deselect All Count(" + _vm._s(this.AllModule_ids.length) + ")")]), _vm._v(" "), _c('b-button', {
    class: _vm.visible ? null : 'collapsed',
    staticStyle: {
      "font-size": "0.575rem",
      "margin-left": "5px",
      "margin-bottom": "4px"
    },
    attrs: {
      "variant": "outline-dark",
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v("Filters")]), _vm._v(" "), (_vm.$sessionsStorage.get('userId')) ? _c('userBasedClient', {
    attrs: {
      "PMC_title": 'User Summary - ' + _vm.$sessionsStorage.get('employeeName'),
      "PMC_USERID": _vm.$sessionsStorage.get('userId'),
      "PMC_USERNAME": _vm.$sessionsStorage.get('nameUser'),
      "PMC_USERDESIG": _vm.$sessionsStorage.get('designation'),
      "PMC_BranchClientPre": _vm.$sessionsStorage.get('branchclientPre'),
      "PMC_TransportTypePre": _vm.$sessionsStorage.get('transportTypePre'),
      "PMC_UserEmpName": _vm.$sessionsStorage.get('employeeName'),
      "PMC_UserEmpCode": _vm.$sessionsStorage.get('employeeCode')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$sessionsStorage.get('is_Mobile') != 'port') ? _c('b-button', {
    staticStyle: {
      "font-size": "0.575rem",
      "margin-left": "5px",
      "margin-bottom": "4px"
    },
    attrs: {
      "size": "sm",
      "variant": "primary"
    },
    on: {
      "click": _vm.goToMisc
    }
  }, [_vm._v("New Misc Job")]) : _vm._e(), _vm._v(" "), (
    _vm.$sessionsStorage.get('designation') == 'Admin' &&
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh'
  ) ? _c('b-button', {
    staticStyle: {
      "font-size": "0.575rem",
      "margin-left": "5px",
      "margin-bottom": "4px"
    },
    attrs: {
      "size": "sm",
      "variant": "primary"
    },
    on: {
      "click": _vm.goDeleteRequest
    }
  }, [_vm._v("Delete Request")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticStyle: {
      "font-size": "0.575rem",
      "margin-left": "5px",
      "margin-bottom": "4px"
    },
    attrs: {
      "disabled": _vm.ExcelBtnNameCustom !== 'SI VGM Pending',
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReportsCustom('checkJobPendency', 'SI VGM Pending')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.ExcelBtnNameCustom) + "\n          "), (_vm.ExcelBtnNameCustom !== 'SI VGM Pending') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1), _vm._v(" "), (
    _vm.$sessionsStorage.get('designation') == 'Admin' &&
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' &&
    _vm.AllModule_ids.length > 0
  ) ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.removeExpInv
    }
  }, [_vm._v("Delete Exp/Inv")]) : _vm._e(), _vm._v(" "), _c('h5', {
    staticClass: "text-muted pull-right"
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain mt-2"
  }, [_c('b-table', {
    attrs: {
      "fixed": _vm.fixed,
      "show-empty": "",
      "stacked": "md",
      "items": _vm.consoBooking,
      "fields": _vm.fields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "jobType",
      fn: function(row0) {
        return [(row0.item.allModuleId) ? _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.AllModule_ids),
            expression: "AllModule_ids"
          }],
          attrs: {
            "type": "checkbox",
            "id": row0.item.TPTClient
          },
          domProps: {
            "value": row0.item.allModuleId,
            "checked": Array.isArray(_vm.AllModule_ids) ? _vm._i(_vm.AllModule_ids, row0.item.allModuleId) > -1 : (_vm.AllModule_ids)
          },
          on: {
            "change": [function($event) {
              var $$a = _vm.AllModule_ids,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = row0.item.allModuleId,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.AllModule_ids = $$a.concat([$$v]))
                } else {
                  $$i > -1 && (_vm.AllModule_ids = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.AllModule_ids = $$c
              }
            }, function($event) {
              _vm.updateSelectAll($event, row0.item)
            }]
          }
        }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "mainSalesSeries",
      fn: function(row1) {
        return [_c('md-icon', [_vm._v(_vm._s(row1.item.shipmentType == "1" ||
          row1.item.shipmentType == "Sea_Shipment" ?
          "directions_boat" :
          "flight_takeoff"))]), _vm._v(" "), (_vm.$sessionsStorage.get('is_Mobile') == 'port') ? _c('b', [_vm._v(_vm._s(row1.item.mainSalesSeries))]) : _vm._e(), _vm._v(" "), (_vm.$sessionsStorage.get('is_Mobile') != 'port') ? _c('b', {
          staticClass: "showMoreData",
          attrs: {
            "disabled": row1.item.asignDeleted == '1'
          },
          on: {
            "click": function($event) {
              row1.item.isMiscJob == '1' &&
                (row1.item.finalBillingCompleted == 1 ||
                  row1.item.all_locked_counter > 0) &&
                ((row1.item.jobType.indexOf('MISC') >= 0 ||
                  row1.item.jobType.indexOf('YARD') >= 0) && row1.item.is_misc_locked == 1 && (row1.item.finalBillingCompleted == 1 || row1.item.all_locked_counter > 0)) ?
                '' :
                _vm.viewExportFCLConPage(row1.item.allModuleId, row1.item.isMiscJob)
            }
          }
        }, [_vm._v(_vm._s(row1.item.mainSalesSeries))]) : _vm._e(), _vm._v(" "), (row1.item.rollover_event_code == 1) ? _c('span', {
          class: {
            alert: true,
              'alert-danger-text': row1.item.rollover_event_code == 1,
              blink: row1.item.rollover_event_code == 1,
          }
        }, [_c('br'), _vm._v("This Event is Rollover")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Assignment Dt. : " + _vm._s(_vm._f("moment")(row1.item.loginTime)))]), _vm._v(" "), (row1.item.sub_noti_event_message) ? _c('span', [_vm._v("Event MSG : " + _vm._s(row1.item.sub_noti_event_message))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Job Type : " + _vm._s(row1.item.jobType) + " (" + _vm._s(row1.item.shipmentType == "1" ||
          row1.item.shipmentType == "Sea_Shipment" ?
          "Sea" :
          "Air") + "\n                " + _vm._s(row1.item.transportType) + ")\n              ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Raised From : " + _vm._s(row1.item.baseLoc))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(" By : " + _vm._s(row1.item.raisedBy))]), _c('br'), _vm._v(" "), (_vm.$sessionsStorage.get('designation') == 'Admin' &&
          _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' && (row1.item.jobType.indexOf('YARD') >= 0 || row1.item.jobType.indexOf('IB') >= 0 || row1.item.jobType.indexOf('MISC') >= 0)) ? _c('Overseas-CRDRNote', {
          attrs: {
            "title": row1.item.mainSalesSeries,
            "moduleType": 'MISC ' + row1.item.transportType + ' Module',
            "cr_all_module_id": String(row1.item.allModuleId),
            "cr_jb_series": row1.item.mainSalesSeries,
            "cr_ass_date": row1.item.loginTime,
            "transportType": row1.item.transportType,
            "Jobtype": (row1.item.jobType.indexOf('YARD') >= 0 ? 'YARD' : row1.item.jobType.indexOf('IB') >= 0 ? 'IB' : row1.item.jobType.indexOf('MISC') >= 0) ? 'MISC' : '',
            "commonId": '',
            "shipmentType": row1.item.shipmentType == '2' ? 'Air' : 'Sea',
            "isOverseas": false,
            "ItemAr": null
          }
        }) : _vm._e(), _vm._v(" "), (_vm.$sessionsStorage.get('is_Mobile') != 'port') ? _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.showDocModal(row1.item)
            }
          }
        }, [_vm._v("Summary &\n                Documents")]) : _vm._e(), _vm._v(" "), (_vm.$sessionsStorage.get('is_Mobile') != 'port') ? _c('Assignment-Summary', {
          attrs: {
            "title": 'Shipment Summary Tracking - ',
            "assign_date": _vm._f("moment")(row1.item.loginTime),
            "assign_job_type": row1.item.jobType,
            "assign_raised_from": 'Raised From: ' + row1.item.baseLoc,
            "assign_raised_by": 'Raised By: ' + row1.item.raisedBy,
            "fk_all_module_id": row1.item.allModuleId,
            "jb_series": row1.item.mainSalesSeries,
            "fk_client_id": row1.item.clientId,
            "fk_pod_id": row1.item.PODLocationId
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.allModuleId && _vm.$sessionsStorage.get('is_Mobile') != 'port') ? _c('TimelineModal', {
          attrs: {
            "PMC_title": 'Timeline Summary Job No - ' + row1.item.mainSalesSeries,
            "PMC_JOBID": row1.item.allModuleId,
            "PMC_JOBNO": row1.item.mainSalesSeries,
            "PMC_JOBDATE": _vm._f("moment")(row1.item.loginTime),
            "PMC_JOBTYPE": row1.item.jobType,
            "PMC_AgentType": '',
            "PMC_Client": row1.item.TPTClient,
            "PMC_Sline": row1.item.shippingLine
          }
        }) : _vm._e(), _vm._v(" "), (
          row1.item.shipmentType != '2' &&
          _vm.$sessionsStorage.get('designation') == 'Admin' &&
          _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' &&
          _vm.$sessionsStorage.get('is_Mobile') != 'port'
        ) ? _c('Multi-Update', {
          attrs: {
            "title": 'All Update Assignment Detials - ',
            "mu_assign_date": _vm._f("moment")(row1.item.loginTime),
            "mu_assign_job_type": row1.item.jobType,
            "mu_assign_raised_from": 'Raised From: ' + row1.item.baseLoc,
            "mu_assign_raised_by": 'Raised By: ' + row1.item.raisedBy,
            "mu_all_module_id": row1.item.allModuleId,
            "mu_jb_series": row1.item.mainSalesSeries,
            "mu_client_id": row1.item.clientId,
            "mu_pod_id": row1.item.PODLocationId,
            "mu_shipmentType": row1.item.shipmentType,
            "mu_transportType": row1.item.transportType,
            "mu_containerInfo": row1.item.containerInfo,
            "mu_multipleContainerType": row1.item.multipleContainerType,
            "mu_clientType": row1.item.clientType
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.shipmentType == '2' && _vm.$sessionsStorage.get('is_Mobile') != 'port' && _vm.$sessionsStorage.get('designation') == 'Admin' &&
          _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh') ? _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-primary"
          },
          on: {
            "click": function($event) {
              _vm.openAirAssignmentModal(row1)
            }
          }
        }, [_vm._v("\n                Multi-Update\n              ")]) : _vm._e(), _vm._v(" "), (row1.item.shipmentType == '2') ? _c('AirAssignmentModal', {
          ref: 'AirAssignmentModal' + row1.item.allModuleId,
          attrs: {
            "mu_all_module_id": row1.item.allModuleId,
            "mu_jb_series": row1.item.mainSalesSeries,
            "mu_assign_job_type": row1.item.jobType,
            "mu_enq_job_type": row1.item.EnqJob,
            "mu_client_id": row1.item.clientId,
            "mu_item": row1.item
          },
          on: {
            "refresh": function($event) {
              _vm.viewFFExportFCL('0', '1', '1')
            }
          }
        }) : _vm._e(), _vm._v(" "), (
          row1.item.jobType.indexOf('MISC') >= 0 ||
          (row1.item.jobType.indexOf('YARD') >= 0 &&
            _vm.$sessionsStorage.get('is_Mobile') != 'port')
        ) ? _c('CommonLock', {
          attrs: {
            "title": 'Lock and Un-Lock Pannel - ',
            "lock_assign_date": _vm._f("moment")(row1.item.loginTime),
            "lock_assign_job_type": row1.item.jobType,
            "lock_assign_raised_from": 'Raised From: ' + row1.item.baseLoc,
            "lock_assign_raised_by": 'Raised By: ' + row1.item.raisedBy,
            "lock_all_module_id": row1.item.allModuleId,
            "lock_jb_series": row1.item.mainSalesSeries,
            "lock_client_id": row1.item.clientId,
            "lock_pod_id": row1.item.PODLocationId,
            "lock_shipmentType": row1.item.shipmentType,
            "lock_transportType": row1.item.transportType,
            "lock_containerInfo": row1.item.containerInfo,
            "lock_multipleContainerType": row1.item.multipleContainerType,
            "lock_clientType": row1.item.clientType,
            "lock_ff_is_locked": row1.item.ff_is_locked,
            "lock_tpt_is_locked": row1.item.tpt_is_locked,
            "lock_cc_is_locked": row1.item.cc_is_locked,
            "lock_consoli_is_locked": row1.item.consoli_is_locked,
            "lock_all_locked_counter": row1.item.all_locked_counter,
            "lock_all_lock_date_time": row1.item.all_lock_date_time,
            "lock_extra_payment_count": row1.item.extra_payment_count,
            "lock_finalBillingCompleted": row1.item.finalBillingCompleted,
            "lock_item": row1.item,
            "lock_is_misc_locked": row1.item.is_misc_locked == 0 || row1.item.is_misc_locked == 1 ?
              row1.item.is_misc_locked :
              row1.item.isMiscJob
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.allModuleId) ? _c('InvExpSummary', {
          attrs: {
            "PMC_title": 'Inv Exp Summary Job No - ' + row1.item.mainSalesSeries,
            "PMC_JOBID": row1.item.allModuleId,
            "PMC_JOBNO": row1.item.mainSalesSeries,
            "PMC_JOBDATE": _vm._f("moment")(row1.item.loginTime),
            "PMC_JOBTYPE": row1.item.jobType,
            "PMC_AgentType": '',
            "PMC_Client": row1.item.TPTClient,
            "PMC_Sline": row1.item.shippingLine
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.allModuleId) ? _c('ContainerSummary', {
          attrs: {
            "PMC_title": 'Container Summary Job No - ' + row1.item.mainSalesSeries,
            "PMC_JOBID": row1.item.allModuleId,
            "PMC_JOBNO": row1.item.mainSalesSeries,
            "PMC_JOBDATE": _vm._f("moment")(row1.item.loginTime),
            "PMC_JOBTYPE": row1.item.jobType,
            "PMC_AgentType": '',
            "PMC_Client": row1.item.TPTClient,
            "PMC_Sline": row1.item.shippingLine
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.allModuleId) ? _c('AssignmentSplitMergeSummary', {
          attrs: {
            "PMC_title": 'Assignment Split/Merge/Move Summary Job No - ' + row1.item.mainSalesSeries,
            "PMC_JOBID": row1.item.allModuleId,
            "PMC_JOBNO": row1.item.mainSalesSeries,
            "PMC_JOBDATE": _vm._f("moment")(row1.item.loginTime),
            "PMC_JOBTYPE": row1.item.jobType,
            "PMC_AgentType": '',
            "PMC_Client": row1.item.TPTClient,
            "PMC_Sline": row1.item.shippingLine
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.allModuleId) ? _c('RejectInvTallyBillSummary', {
          attrs: {
            "PMC_title": 'Invoice Rejection Log Summary Job No - ' + row1.item.mainSalesSeries,
            "PMC_JOBID": row1.item.allModuleId,
            "PMC_JOBNO": row1.item.mainSalesSeries,
            "PMC_JOBDATE": _vm._f("moment")(row1.item.loginTime),
            "PMC_JOBTYPE": row1.item.jobType,
            "PMC_Client": row1.item.TPTClient,
            "PMC_Sline": row1.item.shippingLine
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.allModuleId) ? _c('JobWisePaymentsDetails', {
          attrs: {
            "allModuleId": Number(row1.item.allModuleId),
            "JobNo": row1.item.mainSalesSeries
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.newfreightContainers && row1.item.jobType.indexOf('FF') >= 0 && row1.item.SubscriptionId) ? _c('BookingTrack', {
          attrs: {
            "containerArr": row1.item.newfreightContainers,
            "slineName": row1.item.shippingLine,
            "clientName": row1.item.TPTClient,
            "modal_title": ("Container Movement Booking No: " + (row1.item.validBookingNo) + " Job No - " + (row1.item.mainSalesSeries) + " Client: " + (row1.item.TPTClient)),
            "JOBNO": row1.item.mainSalesSeries,
            "shipment_id": Number(0),
            "subscription_id": Number(0),
            "fk_sub_track_id": Number(0),
            "fk_all_module_id": Number(row1.item.allModuleId),
            "fk_booking_id": Number(row1.item.fk_booking_id),
            "fk_container_id": Number(0),
            "booking_number": row1.item.validBookingNo,
            "container_number": ''
          }
        }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (row1.item.splitFromId != '0') ? _c('h7', {
          staticClass: "mt-2"
        }, [_c('b-badge', {
          attrs: {
            "variant": "info"
          }
        }, [_vm._v("Split of " + _vm._s(row1.item.splitFromNo))])], 1) : _vm._e(), _vm._v(" "), (
          row1.item.SplitedStatus != '0' &&
          _vm.$sessionsStorage.get('is_Mobile') != 'port'
        ) ? _c('Splitmerge-Summary', {
          staticClass: "mt-2",
          attrs: {
            "title": 'Split & Merge Track - ',
            "SM_all_module_id": row1.item.allModuleId,
            "SM_jb_series": row1.item.mainSalesSeries,
            "SM_Status": 1
          }
        }) : _vm._e(), _vm._v(" "), _c('h6', [(row1.item.asignDeleted == '1') ? _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v("Assignment Deleted")]) : _vm._e()], 1)]
      }
    }, {
      key: "TPTClient",
      fn: function(row11) {
        return [(
          row11.item.clientType == '3' && row11.item.transportType == 'Export'
        ) ? _c('b', [_vm._v("\n                Client Name : " + _vm._s(row11.item.exporter) + "\n                "), _c('br')]) : _vm._e(), _vm._v(" "), (row11.item.clientType == '3') ? _c('b', [_vm._v("\n                Overseas Agent : " + _vm._s(row11.item.TPTClient) + "\n                "), _c('br')]) : _vm._e(), _vm._v(" "), (row11.item.clientType != '3') ? _c('b', [_vm._v("\n                " + _vm._s(row11.item.TPTClient) + "\n                "), _c('br')]) : _vm._e()]
      }
    }, {
      key: "mainEnquirySeries",
      fn: function(row2) {
        return row2.item.EnqJob ? [_c('b', {
          staticClass: "showMoreData",
          staticStyle: {
            "color": "blue"
          },
          on: {
            "click": function($event) {
              _vm.viewExportEnqPage(row2.item.mainEnquiryId)
            }
          }
        }, [_c('u', [_vm._v(_vm._s(row2.item.mainEnquirySeries))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Enquiry Type : " + _vm._s(row2.item.EnqJob) + " (" + _vm._s(row2.item.shipmentType == "1" ? "Sea" : "Air") + "\n                " + _vm._s(row2.item.transportType) + ")")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Enquiry Date : " + _vm._s(_vm._f("moment")(row2.item.enqDate)))])] : undefined
      }
    }, {
      key: "POR",
      fn: function(row7) {
        return [(
          row7.item.shipmentType == '1' ||
          row7.item.shipmentType == 'Sea_Shipment'
        ) ? _c('div', [_c('span', [_vm._v("Container Type : " + _vm._s(row7.item.multipleContainerType))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("No of Containers : " + _vm._s(row7.item.multiConNo))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
          style: (row7.item.SubscriptionId ? 'color: blue;font-weight:bold' : ''),
          on: {
            "click": function($event) {
              row7.item.SubscriptionId ? _vm.goToSubscriptionPage(row7.item) : ''
            }
          }
        }, [_vm._v("Booking No : " + _vm._s(row7.item.validBookingNo))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Shipper INV No : " + _vm._s(row7.item.shipperInvoiceNo))]), _c('br'), _vm._v(" "), (
          row7.item.newContainerFlow == '1' &&
          row7.item.shipmentType == '1' &&
          parseInt(row7.item.multiConNo) !=
          parseInt(row7.item.amendmentContainersCount)
        ) ? _c('span', {
          staticClass: "error"
        }, [_c('b', [_vm._v("Amendment Containers: " + _vm._s(row7.item.amendmentContainersCount))]), _c('br')]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Shipping Line : " + _vm._s(row7.item.shippingLine))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Pickup : " + _vm._s(row7.item.pickup))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Stuffing : " + _vm._s(row7.item.stuffingLoc))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Handover : " + _vm._s(row7.item.handover))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Place of Receipt : " + _vm._s(row7.item.POR))]), _vm._v(" "), _c('br'), _vm._v(" "), (row7.item.jobType.split(',').includes('FF')) ? _c('div', [_c('span', [_vm._v("Load Port : " + _vm._s(row7.item.LP))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Port of Discharge : " + _vm._s(row7.item.POD))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Final Place of Delivery : " + _vm._s(row7.item.finalPlace))])]) : _vm._e()]) : _c('div', [_c('span', [_vm._v("\n                  Departure Airport : " + _vm._s(row7.item.AirDept) + "\n                  "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                  Destination Airport : " + _vm._s(row7.item.airDesti) + "\n                  "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                  No.of Packages : " + _vm._s(row7.item.noOfPkg) + "\n                  "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                  Cargo Received At :\n                  " + _vm._s(row7.item.cargoReceived == "1" ? "Airport" : "Warehouse") + "\n                  "), _c('br')])])]
      }
    }, {
      key: "deleteRequest",
      fn: function(row10) {
        return [_c('td', [(
          row10.item.deleteRequest == '0' &&
          _vm.$sessionsStorage.get('is_Mobile') != 'port'
        ) ? _c('b', {
          staticClass: "showMoreData",
          staticStyle: {
            "color": "red"
          },
          on: {
            "click": function($event) {
              _vm.CompleteRemoveASS(
                row10.item.allModuleId,
                '1',
                row10.item.mainSalesSeries
              )
            }
          }
        }, [_vm._v("Request To Delete Assignment")]) : _vm._e(), _vm._v(" "), (
          row10.item.deleteRequest == '0' &&
          _vm.$sessionsStorage.get('is_Mobile') != 'port'
        ) ? _c('br') : _vm._e(), _vm._v(" "), (
          row10.item.deleteRequest == '1' &&
          row10.item.ApproveRejectDelReq == '0' &&
          (_vm.$sessionsStorage.get('designation') == 'manager' ||
            _vm.$sessionsStorage.get('designation') == 'employee')
        ) ? _c('b', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("Sent For Delete Approval")]) : _vm._e(), _vm._v(" "), (
          row10.item.deleteRequest == '1' &&
          row10.item.ApproveRejectDelReq == '0' &&
          (_vm.$sessionsStorage.get('designation') == 'manager' ||
            _vm.$sessionsStorage.get('designation') == 'employee') &&
          _vm.$sessionsStorage.get('is_Mobile') != 'port'
        ) ? _c('br') : _vm._e(), _vm._v(" "), (
          row10.item.deleteRequest == '1' &&
          row10.item.ApproveRejectDelReq != '2' &&
          (_vm.$sessionsStorage.get('designation') == 'Admin' ||
            _vm.$sessionsStorage.get('designation') == 'HOD') &&
          _vm.$sessionsStorage.get('is_Mobile') != 'port'
        ) ? _c('b', {
          staticClass: "showMoreData",
          staticStyle: {
            "color": "red"
          },
          on: {
            "click": function($event) {
              _vm.CompleteRemoveASS(
                row10.item.allModuleId,
                '2',
                row10.item.mainSalesSeries
              )
            }
          }
        }, [_vm._v("Approve Delete Request /")]) : _vm._e(), _vm._v(" "), (
          row10.item.deleteRequest == '1' &&
          row10.item.ApproveRejectDelReq != '2' &&
          _vm.$sessionsStorage.get('is_Mobile') != 'port'
        ) ? _c('b', {
          staticClass: "showMoreData",
          staticStyle: {
            "color": "red"
          },
          on: {
            "click": function($event) {
              _vm.CompleteRemoveASS(
                row10.item.allModuleId,
                '3',
                row10.item.mainSalesSeries
              )
            }
          }
        }, [_vm._v("Reject Delete Request")]) : _vm._e(), _vm._v(" "), (
          row10.item.deleteRequest == '0' &&
          row10.item.ApproveRejectDelReq != '2' &&
          _vm.$sessionsStorage.get('is_Mobile') != 'port'
        ) ? _c('br') : _vm._e(), _vm._v(" "), (
          row10.item.ApproveRejectDelReq == '2' &&
          row10.item.asignDeleted != '1' &&
          _vm.$sessionsStorage.get('is_Mobile') != 'port'
        ) ? _c('b', {
          staticClass: "showMoreData",
          staticStyle: {
            "color": "red"
          },
          on: {
            "click": function($event) {
              _vm.CompleteRemoveASS(
                row10.item.allModuleId,
                '4',
                row10.item.mainSalesSeries
              )
            }
          }
        }, [_vm._v("Delete Assignment")]) : _vm._e(), _vm._v(" "), (row10.item.asignDeleted == '1') ? _c('b', {
          staticStyle: {
            "color": "red"
          }
        }) : _vm._e(), _vm._v(" "), (
          row10.item.deleteRequest == '1' &&
          row10.item.ApproveRejectDelReq == '0' &&
          (_vm.$sessionsStorage.get('designation') == 'manager' ||
            _vm.$sessionsStorage.get('designation') == 'employee')
        ) ? _c('b', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("Sent For Delete Approval")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (
          row10.item.deleteRequestBy != '' &&
          row10.item.deleteRequestBy != '0' &&
          row10.item.deleteRequestBy != null
        ) ? _c('b', [_vm._v("Requested By : " + _vm._s(row10.item.deleteRequestBy)), _c('br')]) : _vm._e(), _vm._v(" "), (
          row10.item.finalBillingCompleted != '1' &&
          _vm.$sessionsStorage.get('designation') == 'Admin' &&
          _vm.$sessionsStorage.get('is_Mobile') != 'port'
        ) ? _c('b-button', {
          staticClass: "mt-2 mb-1x",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.closeBillModal(row10.item.allModuleId, row10.item.jobType)
            }
          }
        }, [_vm._v("Close Billing")]) : _vm._e(), _vm._v(" "), (
          row10.item.finalBillingCompleted == '1' &&
          row10.item.assignmentCloseReason
        ) ? _c('span', {
          staticStyle: {
            "color": "green"
          },
          domProps: {
            "innerHTML": _vm._s(row10.item.assignmentCloseReason)
          }
        }, [_vm._v(_vm._s(_vm.wordWrap(row10.item.assignmentCloseReason, 24)))]) : _vm._e(), _vm._v(" "), (
          row10.item.fk_loss_job_user_id &&
          row10.item.known_loss_job_remark
        ) ? _c('span', {
          domProps: {
            "innerHTML": _vm._s(row10.item.known_loss_job_remark)
          }
        }, [_vm._v(_vm._s(_vm.wordWrap(row10.item.known_loss_job_remark, 24)) + "\n                  "), _c('br')]) : _vm._e(), _vm._v(" "), (
          row10.item.fk_loss_job_user_id &&
          row10.item.known_loss_job_remark
        ) ? _c('span', [_vm._v("User Name:" + _vm._s(row10.item.loss_job_user)), _c('br'), _vm._v("Loss Job Date:" + _vm._s(row10.item.known_loss_job_date)), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.$sessionsStorage.get('is_Mobile') != 'port') ? _c('Add-Message', {
          staticStyle: {
            "list-style-type": "none"
          },
          attrs: {
            "fk_all_module_id": row10.item.allModuleId,
            "fk_client_id": row10.item.clientId,
            "fk_pod_id": row10.item.PODLocationId
          }
        }) : _vm._e(), _vm._v(" "), _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.PortExpense(row10.item.allModuleId, row10.item.jobType, row10.item)
            }
          }
        }, [_vm._v("Port Expense")])], 1)]
      }
    }, {
      key: "action",
      fn: function(row3) {
        return [(_vm.adminToggle == 'Admin' && row3.item.asignDeleted == 1) ? _c('div', {
          attrs: {
            "id": 'row' + row3.item.allModuleId
          }
        }, [_c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row3.item.allModuleId,
            "name": "approval",
            "value": row3.item.asignDeleted == 1 ? true : false
          },
          on: {
            "change": function($event) {
              _vm.activateUserMultiple(row3.item)
            }
          }
        }, [_c('h6', [_c('br'), _vm._v(" "), _c('b-badge', {
          staticStyle: {
            "margin-left": "-45px"
          }
        }, [_vm._v(_vm._s(row3.item.asignDeleted == 1 ? "Deleted" : "Not Deleted"))])], 1)])], 1) : _vm._e()]
      }
    }])
  })], 1)]), _vm._v(" "), _c('div', [_c('h5', [_c('div', [_c('b-pagination', {
    attrs: {
      "imit": "5",
      "align": "center",
      "per-page": _vm.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)])])], 1)], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": 'Assignment Summary & Documents - ' + _vm.JOBSERIES
    }
  }, [(_vm.ALLMODULE) ? _c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close\n      ")])], 1), _vm._v(" "), _c('b-modal', {
    ref: "modal-close-conf",
    attrs: {
      "id": "modal-close-conf",
      "title": "Reason for Closing Assignment Billing",
      "centered": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('h3', [_vm._v("Confirmation")]), _vm._v(" "), _c('form', {
    ref: "form"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Remark",
      "label-for": "name-input",
      "invalid-feedback": "Name is required"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "rows": "5",
      "id": "name-input",
      "required": ""
    },
    model: {
      value: (_vm.billingclosingReason),
      callback: function($$v) {
        _vm.billingclosingReason = $$v
      },
      expression: "billingclosingReason"
    }
  })], 1)], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "disabled": _vm.billingclosingReason ? false : true,
      "variant": "success"
    },
    on: {
      "click": _vm.closeBillOk
    }
  }, [_vm._v("\n        Confirm & Close Billing")]), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.closeModalConfirm
    }
  }, [_vm._v("\n        Cancel")])], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "modal-INVEXP-conf",
    attrs: {
      "id": "modal-INVEXP-conf",
      "title": "Confirmation Remove Invoice Expenses Choose Option",
      "centered": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12",
      "align": "center"
    }
  }, [_c('b-button', {
    staticClass: "mt-2 mb-5 mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "sm",
      "variant": _vm.DeleteType == 'Exp' ? 'success' : 'outline-info'
    },
    on: {
      "click": function($event) {
        _vm.DeleteTypeFunc('Exp')
      }
    },
    model: {
      value: (_vm.DeleteType),
      callback: function($$v) {
        _vm.DeleteType = $$v
      },
      expression: "DeleteType"
    }
  }, [_vm._v("Expense")]), _vm._v(" "), _c('b-button', {
    staticClass: "mt-2 mb-5 mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "sm",
      "variant": _vm.DeleteType == 'Inv' ? 'success' : 'outline-info'
    },
    on: {
      "click": function($event) {
        _vm.DeleteTypeFunc('Inv')
      }
    },
    model: {
      value: (_vm.DeleteType),
      callback: function($$v) {
        _vm.DeleteType = $$v
      },
      expression: "DeleteType"
    }
  }, [_vm._v("Invocie")]), _vm._v(" "), _c('b-button', {
    staticClass: "mt-2 mb-5 mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "sm",
      "variant": _vm.DeleteType == 'Both' ? 'success' : 'outline-info'
    },
    on: {
      "click": function($event) {
        _vm.DeleteTypeFunc('Both')
      }
    },
    model: {
      value: (_vm.DeleteType),
      callback: function($$v) {
        _vm.DeleteType = $$v
      },
      expression: "DeleteType"
    }
  }, [_vm._v("Both")])], 1)], 1), _vm._v(" "), _c('b-button', {
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.DeleteType ? false : true,
      "variant": "success"
    },
    on: {
      "click": _vm.CompleteRemoveExpInv
    }
  }, [_vm._v("\n      Confirm & Remove")]), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.closeModalRemoveExpInv
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('b-modal', {
    ref: "modal-AssRemove-conf",
    attrs: {
      "id": "modal-AssRemove-conf",
      "title": "Confirmation Remove Assignment",
      "centered": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "error",
    attrs: {
      "md": "12",
      "align": "center"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.PaymentType))])])], 1), _vm._v(" "), _c('b-button', {
    staticClass: "pull-left",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.closeModalRemoveAss
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.execActions(_vm.PaymentTypeModuleId, _vm.PaymentTypeID, _vm.PaymentTypeJOBNo)
      }
    }
  }, [_vm._v("\n      Yes")])], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopMail",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAction
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopApprove",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAction
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopReject",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAction
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopDelete",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAction
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42842bf2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/allModuleForm/viewAllModuleDetails.vue
// module id = 2561
// module chunks = 0